import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { StepConnector } from '@material-ui/core';

const styles = ({ spacing: { unit } }) => ({
  alternativeLabel: {
    '&$first': {
      left: 'calc(-100% + 40px)',
      right: 'calc(50% + 20px)',
    },
    '&$last': {
      left: `calc(-50% + ${unit * 2}px)`,
      right: `calc(0% + ${unit * 4}px)`,
    },
  },
  first: {},
  last: {},
});

const Connector = ({ classes, index, ...props }) => (
  <StepConnector
    classes={{
      alternativeLabel: classnames(classes.alternativeLabel, {
        [classes.first]: index === 1,
        [classes.last]: index === 2,
      }),
    }}
    {...props}
  />
);

Connector.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Connector);
